import styled from 'styled-components';

export const UiDropzoneUploader = styled.div`
	display: block;
`;
